"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EN_SHOME_TARGET_TYPE = exports.EN_SHOME_TARGET = void 0;
var EN_SHOME_TARGET;
(function (EN_SHOME_TARGET) {
    EN_SHOME_TARGET[EN_SHOME_TARGET["HOTEL"] = 0] = "HOTEL";
    EN_SHOME_TARGET[EN_SHOME_TARGET["PENSION"] = 1] = "PENSION";
    // DEPRECATED
    EN_SHOME_TARGET[EN_SHOME_TARGET["GLOBAL"] = 2] = "GLOBAL";
    EN_SHOME_TARGET[EN_SHOME_TARGET["MAIN_HOME"] = 3] = "MAIN_HOME";
    EN_SHOME_TARGET[EN_SHOME_TARGET["MOTEL"] = 4] = "MOTEL";
    EN_SHOME_TARGET[EN_SHOME_TARGET["GUESTHOUSE"] = 5] = "GUESTHOUSE";
    EN_SHOME_TARGET[EN_SHOME_TARGET["MYROOM"] = 6] = "MYROOM";
    EN_SHOME_TARGET[EN_SHOME_TARGET["LEISURE"] = 7] = "LEISURE";
    EN_SHOME_TARGET[EN_SHOME_TARGET["GLOBAL_STAY"] = 8] = "GLOBAL_STAY";
    EN_SHOME_TARGET[EN_SHOME_TARGET["GLOBAL_STAY_DETAIL"] = 9] = "GLOBAL_STAY_DETAIL";
    EN_SHOME_TARGET[EN_SHOME_TARGET["MY_YANOLJA_TOP"] = 10] = "MY_YANOLJA_TOP";
    EN_SHOME_TARGET[EN_SHOME_TARGET["MY_YANOLJA_BOTTOM"] = 11] = "MY_YANOLJA_BOTTOM";
    EN_SHOME_TARGET[EN_SHOME_TARGET["RAILROAD"] = 12] = "RAILROAD";
    EN_SHOME_TARGET[EN_SHOME_TARGET["MY_YANOLJA_COUPON"] = 13] = "MY_YANOLJA_COUPON";
    EN_SHOME_TARGET[EN_SHOME_TARGET["GLOBAL_RESERVE_LIST"] = 14] = "GLOBAL_RESERVE_LIST";
    EN_SHOME_TARGET[EN_SHOME_TARGET["GLOBAL_LEISURE"] = 15] = "GLOBAL_LEISURE";
    EN_SHOME_TARGET[EN_SHOME_TARGET["MEMBER_LOGIN"] = 16] = "MEMBER_LOGIN";
})(EN_SHOME_TARGET = exports.EN_SHOME_TARGET || (exports.EN_SHOME_TARGET = {}));
// Benefit 배너를 분류할 때도 사용된다.
var EN_SHOME_TARGET_TYPE;
(function (EN_SHOME_TARGET_TYPE) {
    /** 호텔 서브홈 */
    EN_SHOME_TARGET_TYPE["HOTEL"] = "HOTEL";
    /** 펜션 서브홈 */
    EN_SHOME_TARGET_TYPE["PENSION"] = "PENSION";
    /** [DEPRECATED] 글로벌 숙소 서브홈 */
    EN_SHOME_TARGET_TYPE["GLOBAL"] = "GLOBAL";
    /** 야놀자 메인홈(최상단) */
    EN_SHOME_TARGET_TYPE["MAIN_HOME"] = "MAIN_HOME";
    /** 모텔 서브홈 */
    EN_SHOME_TARGET_TYPE["MOTEL"] = "MOTEL";
    /** 게스트하우스 서브홈 */
    EN_SHOME_TARGET_TYPE["GUESTHOUSE"] = "GUESTHOUSE";
    /** 무한쿠폰룸(구 마이룸) 서브홈 */
    EN_SHOME_TARGET_TYPE["MYROOM"] = "MYROOM";
    /** 국내레저 서브홈 */
    EN_SHOME_TARGET_TYPE["LEISURE"] = "LEISURE";
    /** 해외 숙소 서브홈 */
    EN_SHOME_TARGET_TYPE["GLOBAL_STAY"] = "GLOBAL_STAY";
    /** 해외 숙소 상세(pdp) */
    EN_SHOME_TARGET_TYPE["GLOBAL_STAY_DETAIL"] = "GLOBAL_STAY_DETAIL";
    /** 마이 야놀자 - 상단 */
    EN_SHOME_TARGET_TYPE["MY_YANOLJA_TOP"] = "MY_YANOLJA_TOP";
    /** 마이 야놀자 - 하단 */
    EN_SHOME_TARGET_TYPE["MY_YANOLJA_BOTTOM"] = "MY_YANOLJA_BOTTOM";
    /** 기차 서브홈 */
    EN_SHOME_TARGET_TYPE["RAILROAD"] = "RAILROAD";
    /** 마이야놀자 회원 쿠폰함 */
    EN_SHOME_TARGET_TYPE["MY_YANOLJA_COUPON"] = "MY_YANOLJA_COUPON";
    /** 해외숙소 예약 리스트 배너 */
    EN_SHOME_TARGET_TYPE["GLOBAL_RESERVE_LIST"] = "GLOBAL_RESERVE_LIST";
    /** 해외 레저 - 서브홈 */
    EN_SHOME_TARGET_TYPE["GLOBAL_LEISURE"] = "GLOBAL_LEISURE";
    /** 회원 - 로그인 */
    EN_SHOME_TARGET_TYPE["MEMBER_LOGIN"] = "MEMBER_LOGIN";
})(EN_SHOME_TARGET_TYPE = exports.EN_SHOME_TARGET_TYPE || (exports.EN_SHOME_TARGET_TYPE = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRU5fU0hPTUVfVEFSR0VULmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL3NhcHBvcm8vY29uc3RhbnQvZW51bS9zSG9tZS9FTl9TSE9NRV9UQVJHRVQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsSUFBWSxlQW1CWDtBQW5CRCxXQUFZLGVBQWU7SUFDekIsdURBQUssQ0FBQTtJQUNMLDJEQUFPLENBQUE7SUFDUCxhQUFhO0lBQ2IseURBQU0sQ0FBQTtJQUNOLCtEQUFTLENBQUE7SUFDVCx1REFBSyxDQUFBO0lBQ0wsaUVBQVUsQ0FBQTtJQUNWLHlEQUFNLENBQUE7SUFDTiwyREFBTyxDQUFBO0lBQ1AsbUVBQVcsQ0FBQTtJQUNYLGlGQUFrQixDQUFBO0lBQ2xCLDBFQUFjLENBQUE7SUFDZCxnRkFBaUIsQ0FBQTtJQUNqQiw4REFBUSxDQUFBO0lBQ1IsZ0ZBQWlCLENBQUE7SUFDakIsb0ZBQW1CLENBQUE7SUFDbkIsMEVBQWMsQ0FBQTtJQUNkLHNFQUFZLENBQUE7QUFDZCxDQUFDLEVBbkJXLGVBQWUsR0FBZix1QkFBZSxLQUFmLHVCQUFlLFFBbUIxQjtBQUVELDJCQUEyQjtBQUMzQixJQUFZLG9CQW1DWDtBQW5DRCxXQUFZLG9CQUFvQjtJQUM5QixhQUFhO0lBQ2IsdUNBQWUsQ0FBQTtJQUNmLGFBQWE7SUFDYiwyQ0FBbUIsQ0FBQTtJQUNuQiw4QkFBOEI7SUFDOUIseUNBQWlCLENBQUE7SUFDakIsbUJBQW1CO0lBQ25CLCtDQUF1QixDQUFBO0lBQ3ZCLGFBQWE7SUFDYix1Q0FBZSxDQUFBO0lBQ2YsaUJBQWlCO0lBQ2pCLGlEQUF5QixDQUFBO0lBQ3pCLHVCQUF1QjtJQUN2Qix5Q0FBaUIsQ0FBQTtJQUNqQixlQUFlO0lBQ2YsMkNBQW1CLENBQUE7SUFDbkIsZ0JBQWdCO0lBQ2hCLG1EQUEyQixDQUFBO0lBQzNCLG9CQUFvQjtJQUNwQixpRUFBeUMsQ0FBQTtJQUN6QyxrQkFBa0I7SUFDbEIseURBQWlDLENBQUE7SUFDakMsa0JBQWtCO0lBQ2xCLCtEQUF1QyxDQUFBO0lBQ3ZDLGFBQWE7SUFDYiw2Q0FBcUIsQ0FBQTtJQUNyQixtQkFBbUI7SUFDbkIsK0RBQXVDLENBQUE7SUFDdkMscUJBQXFCO0lBQ3JCLG1FQUEyQyxDQUFBO0lBQzNDLGtCQUFrQjtJQUNsQix5REFBaUMsQ0FBQTtJQUNqQyxlQUFlO0lBQ2YscURBQTZCLENBQUE7QUFDL0IsQ0FBQyxFQW5DVyxvQkFBb0IsR0FBcEIsNEJBQW9CLEtBQXBCLDRCQUFvQixRQW1DL0IifQ==